import React from 'react';
import Helpers from '~/utils/Helpers';
import LibraryViewSummary from '~/library/containers/LibraryViewSummary';
import LibraryViewVersion from '~/library/containers/LibraryViewVersion';
import LibraryViewCommitHash from '~/library/containers/LibraryViewCommitHash';
import HorizontalTabItem from '~/components/HorizontalTabItem';
type LibraryViewTabSectionProps = {
  libraryState: object;
};
const LibraryViewTabSection: React.SFC<LibraryViewTabSectionProps> = props => {
  const { libraryState } = props;
  const {
    component = {},
    url: baseUrl,
    tab: activeTab,
    version: libVersion,
    commitHash: libCommitHash,
  } = libraryState;
  const { libraryModel = {} } = component;
  const { versions = [], languageType = '' } = libraryModel;
  const hasVersions = versions.filter(version => version.version !== 'HEAD').length > 0;
  const version =
    libVersion && libVersion !== 'HEAD' ? libVersion : component && component.latestReleaseVersion;
  const head = versions.find(versionObj => versionObj.version === 'HEAD') || {};
  const latestCommitsPreview = head.latestCommitsPreview;
  const latestCommit = latestCommitsPreview && latestCommitsPreview[0];
  const commitHash = libCommitHash || latestCommit;
  const summaryUrl = baseUrl + '/summary';
  const versionUrl =
    baseUrl + '/versions' + (version ? '/' + ((hasVersions && version) || '-') : '');
  const commitHashUrl = baseUrl + '/commit_hash' + (commitHash ? '/' + commitHash : '');
  const tabElementLookup = {
    summary: <LibraryViewSummary libraryState={libraryState} />,
    versions: <LibraryViewVersion libraryState={libraryState} />,
    commit_hash: <LibraryViewCommitHash libraryState={libraryState} />,
  };
  const tabElement = tabElementLookup[activeTab];
  return (
    <div className="mt">
      <div className="bo--1 mb bg-color--white-light border-color--white-dark bo-rad--3">
        <div className="bo-b--5 border-color--white-dark">
          <HorizontalTabItem
            tab="summary"
            isActive={activeTab === 'summary'}
            link={summaryUrl}
            className="vc-text--bold"
          >
            Summary
          </HorizontalTabItem>
          <HorizontalTabItem
            tab="versions"
            isActive={activeTab === 'versions'}
            link={versionUrl}
            className="vc-text--bold"
          >
            Versions
          </HorizontalTabItem>
          {Helpers.isCommitHashSupportedByLanguage(languageType) && (
            <HorizontalTabItem
              tab="commit_hash"
              isActive={activeTab === 'commit_hash'}
              link={commitHashUrl}
              className="vc-text--bold"
            >
              Commit Hash
            </HorizontalTabItem>
          )}
        </div>
      </div>

      <div className="grid__item col-1-1">{tabElement}</div>
    </div>
  );
};
export default LibraryViewTabSection;
